// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"6c0f2dcd9e34ad03b4c7","453":"4fb2184da77802abeaf1"}[chunkId] + ".js";
};